
import './About.css';

// import required modules

export default function About() {
  return (

    <div className='pt-5'>

      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Repudiandae quidem quaerat placeat possimus, quisquam veritatis ratione ad consequatur eaque laudantium,
        sit consequuntur sunt, numquam aspernatur est neque mollitia iure esse?
      </p>
      

    </div>
  );
}
